<div class="list-item">
  <div class="details">
    <div class="icon-name">
      <rt-icon name="attach-file" margin-right-small-xx [color]="IconColor.Light"></rt-icon>
      {{ attachmentPlaceloader.filename }}
      <span text-light *ngIf="attachmentPlaceloader.fileSize" class="size"
        >({{ attachmentPlaceloader.fileSize | rtFileSize }})</span
      >
    </div>
    <rt-spinner
      *ngIf="attachmentPlaceloader.isLoading"
      class="attachment-spinner"
      variant="small"
      margin-right-small-xx
    ></rt-spinner>
  </div>
  <span *ngIf="attachmentPlaceloader.errorMessage" class="error" padding-lr margin-left>{{
    attachmentPlaceloader.errorMessage
  }}</span>
  <rt-divider variant="line dark" margin-top-small> </rt-divider>
</div>
